import { useGetEventsByShipmentNumber } from '@uturn/api/v1';
import { LoadingSpan } from '@uturn/portal/components';
import { getMonthsFromLocal } from '@uturn/portal/utils/get-months-from-local';
import { Sheet, SheetContent } from '@uturn/ui-kit';
import { EventsFeed } from '../event-feed/events-feed';
import { groupedEventsByDate } from '../event-feed/events-feed.utils';

export function EventsShipmentHistorySheet({
	shipmentNumber,
	openSheet,
	setOpenSheet,
}: {
	openSheet: boolean;
	setOpenSheet: (open: boolean) => void;
	shipmentNumber: string;
}) {
	const months = getMonthsFromLocal({ localeName: navigator.language });

	const {
		data: events,
		isPending,
		isSuccess,
		isError,
	} = useGetEventsByShipmentNumber(Number(shipmentNumber), {
		query: {
			select: (data) => groupedEventsByDate(data.data.flat()),
		},
	});

	return (
		<Sheet open={openSheet} onOpenChange={setOpenSheet}>
			<SheetContent>
				{isPending && <LoadingSpan />}
				{isError && <span className="text-red-500">Error loading events</span>}
				{isSuccess && <EventsFeed events={events} months={months} />}
			</SheetContent>
		</Sheet>
	);
}
